import {
    USER_FAVORITES_LOADING,
    GET_FAVORITES_SUCCESS,
    GET_FAVORITES_FAILURE,
    ADDING_FAVORITE_DASHBOARD,
    POST_FAVORITE_DASHBOARD_SUCCESS,
    POST_FAVORITE_DASHBOARD_FAILURE,
    REMOVING_FAVORITE_DASHBOARD,
    REMOVE_FAVORITE_DASHBOARD_SUCCESS,
    REMOVE_FAVORITE_DASHBOARD_FAILURE,
} from 'redux/reduxConstants';

export function userFavoritesLoading() {
    return { type: USER_FAVORITES_LOADING };
}

export function getFavoritesSuccess(favoriteDashboards) {
    return { type: GET_FAVORITES_SUCCESS, favoriteDashboards };
}

export function getFavoritesFailure(error) {
    return { type: GET_FAVORITES_FAILURE, error };
}

export function addingFavorite() {
    return { type: ADDING_FAVORITE_DASHBOARD };
}

export function postFavoriteDashboardSuccess(dashboard) {
    return { type: POST_FAVORITE_DASHBOARD_SUCCESS, dashboard };
}

export function postFavoriteDashboardFailure(error) {
    return { type: POST_FAVORITE_DASHBOARD_FAILURE, error };
}

export function removingFavorite() {
    return { type: REMOVING_FAVORITE_DASHBOARD };
}

export function removeFavoriteDashboardSuccess(dashboardId) {
    return { type: REMOVE_FAVORITE_DASHBOARD_SUCCESS, dashboardId };
}

export function removeFavoriteDashboardFailure(error) {
    return { type: REMOVE_FAVORITE_DASHBOARD_FAILURE, error };
}
